// import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import axios from 'axios';

// const API = process.env.REACT_APP_BACKEND_URL;

// const AuthContext = createContext(null);

// export function AuthProvider({ children }) {
//   const [user, setUser] = useState(null);
//   const [loading, setLoading] = useState(true);

//   const checkAuth = useCallback(async () => {
//     try {
//       const { data } = await axios.get(`${API}/api/auth/me`, { withCredentials: true });
//       setUser(data);
//     } catch {
//       setUser(false);
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => { checkAuth(); }, [checkAuth]);

//   const login = async (email, password) => {
//     const { data } = await axios.post(`${API}/api/auth/login`, { email, password }, { withCredentials: true });
//     setUser(data);
//     return data;
//   };

//   const logout = async () => {
//     await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true });
//     setUser(false);
//   };

//   return (
//     <AuthContext.Provider value={{ user, loading, login, logout }}>
//       {children}
//     </AuthContext.Provider>
//   );
// }

// export function useAuth() {
//   return useContext(AuthContext);
// }



import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(() => localStorage.getItem('a7_token'));

  const checkAuth = useCallback(async () => {
    const savedToken = localStorage.getItem('a7_token');
    if (!savedToken) {
      setUser(false);
      setLoading(false);
      return;
    }
    try {
      const { data } = await axios.get(`${API}/api/auth/me`, {
        headers: { Authorization: `Bearer ${savedToken}` },
        withCredentials: true
      });
      setUser(data);
      setToken(savedToken);
    } catch {
      localStorage.removeItem('a7_token');
      setToken(null);
      setUser(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/api/auth/login`, { email, password }, { withCredentials: true });
    const accessToken = data.access_token;
    localStorage.setItem('a7_token', accessToken);
    setToken(accessToken);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await axios.post(`${API}/api/auth/logout`, {}, { withCredentials: true });
    } catch {}
    localStorage.removeItem('a7_token');
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, token }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
